export const mockData = {
  cities: [
    "Delhi", "Gurgaon", "Noida", "Faridabad", "Mumbai", "Bangalore", "Chennai", 
    "Hyderabad", "Pune", "Kolkata", "Ahmedabad", "Jaipur", "Lucknow", "Kanpur", 
    "Nagpur", "Indore", "Bhopal", "Visakhapatnam", "Patna", "Vadodara", 
    "Ghaziabad", "Ludhiana", "Agra", "Nashik", "Meerut", "Rajkot", 
    "Kalyan-Dombivali", "Vasai-Virar", "Varanasi", "Srinagar", "Aurangabad", "Dhanbad"
  ],

  diseases: [
    "Cataract", "Glaucoma", "Diabetic Retinopathy", "Retinal Detachment", "Myopia",
    "Hyperopia", "Astigmatism", "Squint", "Dry Eyes", "Macular Degeneration",
    "Vitreous Hemorrhage", "Corneal Disorders", "Ptosis", "Chalazion", "Stye"
  ],

  specialties: [
    {
      name: "Ophthalmology",
      description: "Advanced eye care with cutting-edge laser technology and minimally invasive surgical treatments...",
      treatments: [
        "Cataract Surgery",
        "LASIK Eye Surgery",
        "Femto LASIK Surgery",
        "SMILE LASIK Surgery",
        "Glaucoma Surgery",
        "Diabetic Retinopathy",
        "Retinal Detachment",
        "ICL Surgery",
        "Vitrectomy Surgery",
        "PRK LASIK Surgery",
        "Contoura Vision",
        "Phaco Surgery",
        "Squint Surgery"
      ],
      image: "ophthalmology"
    },
    {
      name: "Gall Stone",
      description: "Expert treatment for gallstones using advanced laparoscopic and endoscopic techniques for quick recovery...",
      treatments: [
        "Laparoscopic Cholecystectomy",
        "Endoscopic Stone Removal",
        "ERCP Treatment",
        "Gallbladder Stone Surgery",
        "Bile Duct Stone Treatment",
        "Minimally Invasive Surgery"
      ],
      image: "gallstone"
    },
    {
      name: "Kidney Stone",
      description: "Comprehensive kidney stone treatment with state-of-the-art laser technology and minimally invasive procedures...",
      treatments: [
        "PCNL Surgery",
        "URS Treatment",
        "ESWL Therapy",
        "Laser Lithotripsy",
        "Kidney Stone Removal",
        "Ureteroscopic Surgery"
      ],
      image: "kidneystone"
    },
    {
      name: "Piles",
      description: "Advanced hemorrhoid treatment with painless procedures and quick recovery options for all grades...",
      treatments: [
        "Laser Piles Treatment",
        "Stapler Hemorrhoidectomy",
        "Rubber Band Ligation",
        "THD Procedure",
        "Sclerotherapy",
        "Open Hemorrhoidectomy"
      ],
      image: "piles"
    },
    {
      name: "Circumcision",
      description: "Safe and effective circumcision procedures with modern techniques ensuring minimal discomfort and quick healing...",
      treatments: [
        "Laser Circumcision",
        "Conventional Circumcision",
        "Preputioplasty",
        "Frenuloplasty",
        "Adult Circumcision",
        "Pediatric Circumcision"
      ],
      image: "circumcision"
    },
    {
      name: "Hernia",
      description: "Expert hernia repair using advanced laparoscopic techniques with mesh reinforcement for lasting results...",
      treatments: [
        "Laparoscopic Hernia Repair",
        "Open Hernia Surgery",
        "Inguinal Hernia Repair",
        "Umbilical Hernia Repair",
        "Ventral Hernia Repair",
        "Mesh Hernia Surgery"
      ],
      image: "hernia"
    }
  ],

  hospitals: [
    {
      name: "TheLivCure Elantis",
      rating: 4.7,
      reviews: 93,
      address: "29, Ring Road, Block L, Lajpat Nagar, Delhi - 110024",
      features: ["NABH", "24x7 Open", "Emergency Care"],
      description: "TheLivCure Elantis is dedicated to revolutionising surgical care. We combine the latest medical technology with highly skilled professionals and a patient-centric approach to transform the healthcare experience..."
    },
    {
      name: "TheLivCure Gurgaon",
      rating: 4.8,
      reviews: 156,
      address: "Sector 14, Golf Course Road, Gurgaon - 122001",
      features: ["NABH", "24x7 Open", "Emergency Care"],
      description: "State-of-the-art facility providing comprehensive surgical care with modern equipment and experienced medical professionals..."
    },
    {
      name: "TheLivCure Mumbai Central",
      rating: 4.6,
      reviews: 234,
      address: "Tardeo Road, Mumbai Central, Mumbai - 400034",
      features: ["NABH", "24x7 Open", "Emergency Care"],
      description: "Premier healthcare facility in Mumbai offering advanced surgical treatments with personalized care..."
    }
  ],

  stats: [
    { number: "500K+", label: "Eye Surgeries", icon: "activity" },
    { number: "50+", label: "Eye Clinics", icon: "building" },
    { number: "30+", label: "Cities", icon: "map-pin" },
    { number: "98%", label: "Success Rate", icon: "users" },
    { number: "100+", label: "Eye Specialists", icon: "user-check" },
    { number: "24/7", label: "Emergency Care", icon: "hospital" }
  ],

  doctors: [
    {
      name: "Dr. Rajesh Kumar",
      specialty: "Ophthalmology",
      experience: "15+ years",
      rating: 4.8,
      image: "doctor1",
      hospital: "TheLivCure Elantis",
      city: "Delhi"
    },
    {
      name: "Dr. Priya Sharma",
      specialty: "Ophthalmology",
      experience: "12+ years",
      rating: 4.9,
      image: "doctor2",
      hospital: "TheLivCure Gurgaon",
      city: "Gurgaon"
    },
    {
      name: "Dr. Amit Singh",
      specialty: "Ophthalmology",
      experience: "18+ years",
      rating: 4.7,
      image: "doctor3",
      hospital: "TheLivCure Mumbai Central",
      city: "Mumbai"
    },
    {
      name: "Dr. Sunita Verma",
      specialty: "Ophthalmology",
      experience: "20+ years",
      rating: 4.9,
      image: "doctor4",
      hospital: "TheLivCure Elantis",
      city: "Delhi"
    },
    {
      name: "Dr. Vikash Gupta",
      specialty: "Ophthalmology",
      experience: "10+ years",
      rating: 4.6,
      image: "doctor5",
      hospital: "TheLivCure Gurgaon",
      city: "Gurgaon"
    }
  ],

  timeSlots: [
    "09:00 AM", "09:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
    "02:00 PM", "02:30 PM", "03:00 PM", "03:30 PM", "04:00 PM", "04:30 PM",
    "05:00 PM", "05:30 PM", "06:00 PM", "06:30 PM"
  ],

  clinics: [
    {
      id: "clinic_1",
      name: "TheLivCure Eye Care Center - Delhi",
      city: "Delhi",
      address: "29, Ring Road, Block L, Lajpat Nagar, Delhi - 110024",
      phone: "+91 93117 20045",
      specialties: ["Ophthalmology"],
      facilities: ["LASIK Surgery", "Cataract Surgery", "Glaucoma Treatment"]
    },
    {
      id: "clinic_2", 
      name: "TheLivCure Vision Center - Gurgaon",
      city: "Gurgaon",
      address: "Sector 14, Golf Course Road, Gurgaon - 122001",
      phone: "+91-124-456-7890",
      specialties: ["Ophthalmology"],
      facilities: ["Retinal Surgery", "ICL Surgery", "Diabetic Retinopathy"]
    },
    {
      id: "clinic_3",
      name: "TheLivCure Eye Hospital - Mumbai",
      city: "Mumbai", 
      address: "Tardeo Road, Mumbai Central, Mumbai - 400034",
      phone: "+91-22-2345-6789",
      specialties: ["Ophthalmology"],
      facilities: ["SMILE LASIK", "Vitrectomy", "Squint Surgery"]
    }
  ]
};